const Invoice = {
  No: "Invoice.No",
  State_0: "Invoice.State_0",
  State_1: "Invoice.State_1",
  State_2: "Invoice.State_2",
  State_3: "Invoice.State_3",
  State_4: "Invoice.State_4",
  State_5: "Invoice.State_5",
  State_6: "Invoice.State_6",
  State_7: "Invoice.State_7",
  State_100: "Invoice.State_100",
  WidgetState_0: "Invoice.WidgetState_0",
  WidgetState_1: "Invoice.WidgetState_1",
  WidgetState_2: "Invoice.WidgetState_2",
  WidgetState_3: "Invoice.WidgetState_3",
  WidgetState_4: "Invoice.WidgetState_4",
  WidgetState_5: "Invoice.WidgetState_5",
  StateFlowState_0: "Invoice.StateFlowState_0",
  StateFlowState_1: "Invoice.StateFlowState_1",
  StateFlowState_2: "Invoice.StateFlowState_2",
  StateFlowState_3: "Invoice.StateFlowState_3",
  StateFlowState_4: "Invoice.StateFlowState_4",
  StateFlowState_6: "Invoice.StateFlowState_6",
  StateFlowState_100: "Invoice.StateFlowState_100",
  PaymentStatus_0: "Invoice.PaymentStatus_0",
  PaymentStatus_1: "Invoice.PaymentStatus_1",
  PaymentStatus_2: "Invoice.PaymentStatus_2",
  PaymentStatus_3: "Invoice.PaymentStatus_3",
  PaymentStatus_4: "Invoice.PaymentStatus_4",
  PaymentStatus_5: "Invoice.PaymentStatus_5",
  CreditViewStatus_0: "Invoice.CreditViewStatus_0",
  CreditViewStatus_1: "Invoice.CreditViewStatus_1",
  CreditViewStatus_2: "Invoice.CreditViewStatus_2",
  PaymentViewStatus_0: "Invoice.PaymentViewStatus_0",
  PaymentViewStatus_1: "Invoice.PaymentViewStatus_1",
  PaymentViewStatus_2: "Invoice.PaymentViewStatus_2",
  Draft: "Invoice.Draft",
  Overdue: "Invoice.Overdue",
  InBooks: "Invoice.InBooks",
  Discarded: "Invoice.Discarded",
  ExcludingVat: "Invoice.ExcludingVat",
  PaymentStatus: "Invoice.PaymentStatus",
  InvoiceDate: "Invoice.InvoiceDate",
  DueDate: "Invoice.DueDate",
  CreatedBy: "Invoice.CreatedBy",
  Paid: "Invoice.Paid",
  PartiallyPaid: "Invoice.PartiallyPaid",
  NotPaid: "Invoice.NotPaid",
  UpdateDate: "Invoice.UpdateDate",
  UseToday: "Invoice.UseToday",
  Dimensions: "Invoice.Dimensions",
  ReminderHeader: "Invoice.ReminderHeader",
  ReminderSubHeader: "Invoice.ReminderSubHeader",
  SendReminder: "Invoice.SendReminder",
  ReminderFeeNotPaidHeader: "Invoice.ReminderFeeNotPaidHeader",
  ReminderFeeNotPaidDescription: "Invoice.ReminderFeeNotPaidDescription",
  ReminderFeeNotPaidQuestion: "Invoice.ReminderFeeNotPaidQuestion",
  ReminderFeeNotPaidTotalSum: "Invoice.ReminderFeeNotPaidTotalSum",
  AmountRemaining: "Invoice.AmountRemaining",
  WaitForPayment: "Invoice.WaitForPayment",
  WriteOffReminderFee: "Invoice.WriteOffReminderFee",
  Fee: "Invoice.Fee",
  WriteOffReminderFeeConfirmTitle: "Invoice.WriteOffReminderFeeConfirmTitle",
  WriteOffReminderFeeConfirmDescription: "Invoice.WriteOffReminderFeeConfirmDescription",
  ReminderFeeNotPaidBannerText: "Invoice.ReminderFeeNotPaidBannerText",
  SendInvoiceClaim: "Invoice.SendInvoiceClaim",
  DraftHeader: "Invoice.DraftHeader",
  DraftSubHeader: "Invoice.DraftSubHeader",
  EditInvoice: "Invoice.EditInvoice",
  Edit: "Invoice.Edit",
  Remind: "Invoice.Remind",
  Reminded: "Invoice.Reminded",
  SendMail: "Invoice.SendMail",
  Mail: "Invoice.Mail",
  QuickSend: "Invoice.QuickSend",
  EInvoicePrint: "Invoice.EInvoicePrint",
  Download: "Invoice.Download",
  MarkAsSent: "Invoice.MarkAsSent",
  MarkAsSentWarning: "Invoice.MarkAsSentWarning",
  MarkAsSentAndSend: "Invoice.MarkAsSentAndSend",
  MarkAsSentAndSendWarning: "Invoice.MarkAsSentAndSendWarning",
  SendMailHeader: "Invoice.SendMailHeader",
  SendMailSubHeader: "Invoice.SendMailSubHeader",
  TitleSend: "Invoice.TitleSend",
  Cancel: "Invoice.Cancel",
  CancelWarning: "Invoice.CancelWarning",
  CreateRecurringAction: "Invoice.CreateRecurringAction",
  EditDueDate: "Invoice.EditDueDate",
  EditDueDateDescription: "Invoice.EditDueDateDescription",
  CreditAction: "Invoice.CreditAction",
  CopyAction: "Invoice.CopyAction",
  SendAsTitle: "Invoice.SendAsTitle",
  SendAs: "Invoice.SendAs",
  ReminderDate: "Invoice.ReminderDate",
  ReminderCost: "Invoice.ReminderCost",
  ReminderMessage: "Invoice.ReminderMessage",
  SaveNewReciepient: "Invoice.SaveNewReciepient",
  InvoiceTo: "Invoice.InvoiceTo",
  InvoiceTo2: "Invoice.InvoiceTo2",
  OurReference: "Invoice.OurReference",
  CustomerReference: "Invoice.CustomerReference",
  Owner: "Invoice.Owner",
  Quotes: "Invoice.Quotes",
  WonOrInvoiced: "Invoice.WonOrInvoiced",
  Lost: "Invoice.Lost",
  NoOutcome: "Invoice.NoOutcome",
  QuoteState_0: "Invoice.QuoteState_0",
  QuoteState_1: "Invoice.QuoteState_1",
  QuoteState_2: "Invoice.QuoteState_2",
  QuoteState_3: "Invoice.QuoteState_3",
  QuoteState_4: "Invoice.QuoteState_4",
  QuoteState_5: "Invoice.QuoteState_5",
  QuoteState_6: "Invoice.QuoteState_6",
  HelpTextQuoteNumber: "Invoice.HelpTextQuoteNumber",
  HelpTextQuoteOwner: "Invoice.HelpTextQuoteOwner",
  HelpTextQuoteSentDate: "Invoice.HelpTextQuoteSentDate",
  HelpTextQuoteEndDate: "Invoice.HelpTextQuoteEndDate",
  HelpTextQuoteCustomer: "Invoice.HelpTextQuoteCustomer",
  HelpTextQuoteStatus: "Invoice.HelpTextQuoteStatus",
  HelpTextQuoteAmount: "Invoice.HelpTextQuoteAmount",
  HelpTextQuoteInvoice: "Invoice.HelpTextQuoteInvoice",
  AmountSentQuotes: "Invoice.AmountSentQuotes",
  SaveEmail: "Invoice.SaveEmail",
  SendEmailFrom: "Invoice.SendEmailFrom",
  SendEmailTo: "Invoice.SendEmailTo",
  SendEmailSubject: "Invoice.SendEmailSubject",
  InvoiceLayout_0: "Invoice.InvoiceLayout_0",
  InvoiceLayout_1: "Invoice.InvoiceLayout_1",
  InvoiceCustomerType_0: "Invoice.InvoiceCustomerType_0",
  InvoiceCustomerType_1: "Invoice.InvoiceCustomerType_1",
  Receiver: "Invoice.Receiver",
  ReceiverDescription: "Invoice.ReceiverDescription",
  ReceiverTabContentTitle: "Invoice.ReceiverTabContentTitle",
  Content: "Invoice.Content",
  ContentDescription: "Invoice.ContentDescription",
  ContentTabContentTitle: "Invoice.ContentTabContentTitle",
  OtherSettings: "Invoice.OtherSettings",
  OtherSettingsDescription: "Invoice.OtherSettingsDescription",
  Customer: "Invoice.Customer",
  SearchCustomerOrCreate: "Invoice.SearchCustomerOrCreate",
  ForwardedCostsAdd: "Invoice.ForwardedCostsAdd",
  ForwardedCostsReminder: "Invoice.ForwardedCostsReminder",
  ForwardedCostsReminderAction: "Invoice.ForwardedCostsReminderAction",
  ForwardedCostsSource: "Invoice.ForwardedCostsSource",
  ForwardedCostsAwaitingBooking: "Invoice.ForwardedCostsAwaitingBooking",
  ForwardedCostsMarkup: "Invoice.ForwardedCostsMarkup",
  ForwardedCostsMarkupForAll: "Invoice.ForwardedCostsMarkupForAll",
  ForwardedCostsMarkupMixed: "Invoice.ForwardedCostsMarkupMixed",
  ForwardedCostsAttachDocuments: "Invoice.ForwardedCostsAttachDocuments",
  ForwardedCostsRemovedForRecurring: "Invoice.ForwardedCostsRemovedForRecurring",
  ForwardedCostsRemovedForCustomerChange: "Invoice.ForwardedCostsRemovedForCustomerChange",
  ForwardedCostsNotRestored: "Invoice.ForwardedCostsNotRestored",
  FetchingAttachments: "Invoice.FetchingAttachments",
  ForwardedCostDocumentNoAccess: "Invoice.ForwardedCostDocumentNoAccess",
  ForwardedCostDocumentNotAttached: "Invoice.ForwardedCostDocumentNotAttached",
  ReferencePerson: "Invoice.ReferencePerson",
  SearchReferencePersons: "Invoice.SearchReferencePersons",
  CreateClient: "Invoice.CreateClient",
  CannotFindClient: "Invoice.CannotFindClient",
  CompanyName: "Invoice.CompanyName",
  CompanyNameHelpText: "Invoice.CompanyNameHelpText",
  SearchInregisters: "Invoice.SearchInregisters",
  CompanySearchResultText: "Invoice.CompanySearchResultText",
  ClientDetails: "Invoice.ClientDetails",
  ClientDetailsAutoFilledText: "Invoice.ClientDetailsAutoFilledText",
  SaveClient: "Invoice.SaveClient",
  ContactDetails: "Invoice.ContactDetails",
  OrganisationNumberOrPersonNumber: "Invoice.OrganisationNumberOrPersonNumber",
  OrganisationNumberHelpText: "Invoice.OrganisationNumberHelpText",
  ReferencePersons: "Invoice.ReferencePersons",
  Persons: "Invoice.Persons",
  ReferencePersonsHelpText: "Invoice.ReferencePersonsHelpText",
  InvoiceAddress: "Invoice.InvoiceAddress",
  DeliveryAddress: "Invoice.DeliveryAddress",
  SameAsDeliveryAddress: "Invoice.SameAsDeliveryAddress",
  Rot: "Invoice.Rot",
  IsClientEntitledToROT: "Invoice.IsClientEntitledToROT",
  PropertyDescription: "Invoice.PropertyDescription",
  UsedInInvoicesWithROT: "Invoice.UsedInInvoicesWithROT",
  Rut: "Invoice.Rut",
  IsClientEntitledToRUT: "Invoice.IsClientEntitledToRUT",
  Autogiro: "Invoice.Autogiro",
  AutogiroHelpText: "Invoice.AutogiroHelpText",
  PayerNumber: "Invoice.PayerNumber",
  PayerNumberHelpText: "Invoice.PayerNumberHelpText",
  GLNNumber: "Invoice.GLNNumber",
  GLNNumberHelpText: "Invoice.GLNNumberHelpText",
  VATNumber: "Invoice.VATNumber",
  VATNumberHelpText: "Invoice.VATNumberHelpText",
  IncludeVATNumberInInvoice: "Invoice.IncludeVATNumberInInvoice",
  IncludeVATNumberInInvoiceHelpText: "Invoice.IncludeVATNumberInInvoiceHelpText",
  DisplaySettings: "Invoice.DisplaySettings",
  InvoiceDesign: "Invoice.InvoiceDesign",
  InvoiceDesignHelpText: "Invoice.InvoiceDesignHelpText",
  ShowCurrencyCode: "Invoice.ShowCurrencyCode",
  ShowCurrencyCodeHelpText: "Invoice.ShowCurrencyCodeHelpText",
  NewCustomer: "Invoice.NewCustomer",
  Product: "Invoice.Product",
  SearchProduct: "Invoice.SearchProduct",
  Article: "Invoice.Article",
  InvoiceText: "Invoice.InvoiceText",
  Quantity: "Invoice.Quantity",
  Unit: "Invoice.Unit",
  Price: "Invoice.Price",
  VAT: "Invoice.VAT",
  VatLockedTooltip: "Invoice.VatLockedTooltip",
  VatResetNotice: "Invoice.VatResetNotice",
  VatResetOnOpenNotice: "Invoice.VatResetOnOpenNotice",
  CreditRowVatMismatch: "Invoice.CreditRowVatMismatch",
  TotalPrice: "Invoice.TotalPrice",
  TotalPriceExVAT: "Invoice.TotalPriceExVAT",
  RotInvoice: "Invoice.RotInvoice",
  RotDescription: "Invoice.RotDescription",
  RotPeriodDescription: "Invoice.RotPeriodDescription",
  PropertyDesignation: "Invoice.PropertyDesignation",
  PropertyDesignationDescription: "Invoice.PropertyDesignationDescription",
  RutInvoice: "Invoice.RutInvoice",
  RutDescription: "Invoice.RutDescription",
  RutPeriodDescription: "Invoice.RutPeriodDescription",
  PersonNumber: "Invoice.PersonNumber",
  CustomerPersonNumber: "Invoice.CustomerPersonNumber",
  PersonNumberDescription: "Invoice.PersonNumberDescription",
  InvoiceDateDescription: "Invoice.InvoiceDateDescription",
  DeliveryDate: "Invoice.DeliveryDate",
  DeliveryDateDescription: "Invoice.DeliveryDateDescription",
  PaymentTermsDescription: "Invoice.PaymentTermsDescription",
  Recurrent: "Invoice.Recurrent",
  RecurrentDescription: "Invoice.RecurrentDescription",
  MessagesAndAttachments: "Invoice.MessagesAndAttachments",
  MessageDescription: "Invoice.MessageDescription",
  AttachmentsDescription: "Invoice.AttachmentsDescription",
  PeriodisationDescription: "Invoice.PeriodisationDescription",
  InvoiceDesignDescription: "Invoice.InvoiceDesignDescription",
  ShowReference: "Invoice.ShowReference",
  ShowReferenceHelpText: "Invoice.ShowReferenceHelpText",
  ShowCustomer: "Invoice.ShowCustomer",
  ShowCustomerHelpText: "Invoice.ShowCustomerHelpText",
  ShowSeller: "Invoice.ShowSeller",
  ShowSellerHelpText: "Invoice.ShowSellerHelpText",
  Seller: "Invoice.Seller",
  SellerDescription: "Invoice.SellerDescription",
  PaymentOption: "Invoice.PaymentOption",
  PaymentOptionHelpText: "Invoice.PaymentOptionHelpText",
  EUVatCategory: "Invoice.EUVatCategory",
  CreateInvoice: "Invoice.CreateInvoice",
  NewInvoice: "Invoice.NewInvoice",
  CustomerCreatedMessage: "Invoice.CustomerCreatedMessage",
  SendMailSuccessMessage: "Invoice.SendMailSuccessMessage",
  MarkedAsSentSuccessMessage: "Invoice.MarkedAsSentSuccessMessage",
  PrintSuccessMessage: "Invoice.PrintSuccessMessage",
  SaveSuccessMessage: "Invoice.SaveSuccessMessage",
  ReferencePersonUpdatedSuccessMessage: "Invoice.ReferencePersonUpdatedSuccessMessage",
  ReferencePersonNameDescription: "Invoice.ReferencePersonNameDescription",
  ReferencePersonEmailDescription: "Invoice.ReferencePersonEmailDescription",
  ReferencePersonPhoneDescription: "Invoice.ReferencePersonPhoneDescription",
  ReferencePersonReferenceCodeDescription: "Invoice.ReferencePersonReferenceCodeDescription",
  ReferenceCodeLabel: "Invoice.ReferenceCodeLabel",
  ReferenceCodeMissingLabel: "Invoice.ReferenceCodeMissingLabel",
  ReferenceCodeChangeLink: "Invoice.ReferenceCodeChangeLink",
  ReferenceCodeTooltipWithPerson: "Invoice.ReferenceCodeTooltipWithPerson",
  ReferenceCodeTooltipNoPerson: "Invoice.ReferenceCodeTooltipNoPerson",
  ReferenceCodeOverwriteWarningText: "Invoice.ReferenceCodeOverwriteWarningText",
  ReferenceCodeRemoveWarningText: "Invoice.ReferenceCodeRemoveWarningText",
  NewReferencePerson: "Invoice.NewReferencePerson",
  MissingReferenceCodeBannerText: "Invoice.MissingReferenceCodeBannerText",
  MissingReferenceCodeBannerLink: "Invoice.MissingReferenceCodeBannerLink",
  MissingReferenceCodeNoPersonBannerText: "Invoice.MissingReferenceCodeNoPersonBannerText",
  CreateClientDescription: "Invoice.CreateClientDescription",
  MailSendFromWarning: "Invoice.MailSendFromWarning",
  MailSendFromSuccess: "Invoice.MailSendFromSuccess",
  SendInfoMessage: "Invoice.SendInfoMessage",
  SendInfoMessageAlreadyPaid: "Invoice.SendInfoMessageAlreadyPaid",
  SaveValueAsCustomer: "Invoice.SaveValueAsCustomer",
  PaymentMethods_0: "Invoice.PaymentMethods_0",
  PaymentMethods_1: "Invoice.PaymentMethods_1",
  PaymentMethods_2: "Invoice.PaymentMethods_2",
  ReviewInvoice: "Invoice.ReviewInvoice",
  ReviewDescription: "Invoice.ReviewDescription",
  ReviewDescriptionSubText: "Invoice.ReviewDescriptionSubText",
  CustomerDuplicateChecking: "Invoice.CustomerDuplicateChecking",
  BasedOnPrevious: "Invoice.BasedOnPrevious",
  InvoiceNumberHashTag: "Invoice.InvoiceNumberHashTag",
  SendMailFromDescription: "Invoice.SendMailFromDescription",
  SendMailToDescription: "Invoice.SendMailToDescription",
  SendMailSubjectDescription: "Invoice.SendMailSubjectDescription",
  SendMailSubjectTemplateValueDescription: "Invoice.SendMailSubjectTemplateValueDescription",
  SendMailMessageDescription: "Invoice.SendMailMessageDescription",
  DueDateUpdatedSuccessMessage: "Invoice.DueDateUpdatedSuccessMessage",
  ReportAsPaidSuccessMessage: "Invoice.ReportAsPaidSuccessMessage",
  CancelSuccessMessage: "Invoice.CancelSuccessMessage",
  SendReminderSuccessMessage: "Invoice.SendReminderSuccessMessage",
  EUVATCategory_0: "Invoice.EUVATCategory_0",
  EUVATCategory_1: "Invoice.EUVATCategory_1",
  EUVATCategory_2: "Invoice.EUVATCategory_2",
  EUVATCategory_24: "Invoice.EUVATCategory_24",
  EUVATCategory_28: "Invoice.EUVATCategory_28",
  EUVATCategory_27: "Invoice.EUVATCategory_27",
  ReminderInvoiceMessageTemplate: "Invoice.ReminderInvoiceMessageTemplate",
  ReminderDateDescription: "Invoice.ReminderDateDescription",
  ReminderCostDescription: "Invoice.ReminderCostDescription",
  ReminderMessageDescription: "Invoice.ReminderMessageDescription",
  OverdueText: "Invoice.OverdueText",
  WhenDidCustomerPay: "Invoice.WhenDidCustomerPay",
  ReportAsPaid: "Invoice.ReportAsPaid",
  ReportAsPaidDescription: "Invoice.ReportAsPaidDescription",
  ChangeDueDate: "Invoice.ChangeDueDate",
  InvoiceNumber: "Invoice.InvoiceNumber",
  Reminders: "Invoice.Reminders",
  Reminder: "Invoice.Reminder",
  ReminderCostSetting: "Invoice.ReminderCostSetting",
  ReminderCostSettingDescription: "Invoice.ReminderCostSettingDescription",
  PenaltyInterestType: "Invoice.PenaltyInterestType",
  PenaltyInterestTypeDescription: "Invoice.PenaltyInterestTypeDescription",
  PenaltyInterest: "Invoice.PenaltyInterest",
  InterestRate: "Invoice.InterestRate",
  PenaltyInterestType_0: "Invoice.PenaltyInterestType_0",
  PenaltyInterestType_1: "Invoice.PenaltyInterestType_1",
  PenaltyInterestType_2: "Invoice.PenaltyInterestType_2",
  AutomaticReminder: "Invoice.AutomaticReminder",
  AutomaticReminderDescription: "Invoice.AutomaticReminderDescription",
  AutomaticReminderDisable: "Invoice.AutomaticReminderDisable",
  AutomaticReminderAmountLimit: "Invoice.AutomaticReminderAmountLimit",
  AutomaticReminderAmountLimitDescription: "Invoice.AutomaticReminderAmountLimitDescription",
  AutomaticReminderAmountLimitControlLabel: "Invoice.AutomaticReminderAmountLimitControlLabel",
  AutomaticReminderPeriod: "Invoice.AutomaticReminderPeriod",
  AutomaticReminderPeriodDescription: "Invoice.AutomaticReminderPeriodDescription",
  AutomaticReminderPeriodControlLabel: "Invoice.AutomaticReminderPeriodControlLabel",
  AutomaticReminderDelay: "Invoice.AutomaticReminderDelay",
  AutomaticReminderDelayDescription: "Invoice.AutomaticReminderDelayDescription",
  AutomaticReminderDelayControlLabel: "Invoice.AutomaticReminderDelayControlLabel",
  AutomaticReminderCountLimit: "Invoice.AutomaticReminderCountLimit",
  AutomaticReminderCountLimitDescription: "Invoice.AutomaticReminderCountLimitDescription",
  AutomaticReminderCountLimitControlLabel: "Invoice.AutomaticReminderCountLimitControlLabel",
  AutomaticReminderNotes: "Invoice.AutomaticReminderNotes",
  AutomaticReminderNotesDescription: "Invoice.AutomaticReminderNotesDescription",
  AutomaticReminderSendType: "Invoice.AutomaticReminderSendType",
  AutomaticReminderSendTypeDescription: "Invoice.AutomaticReminderSendTypeDescription",
  AutomaticReminderSendType_0: "Invoice.AutomaticReminderSendType_0",
  AutomaticReminderSendType_1: "Invoice.AutomaticReminderSendType_1",
  AutomaticReminderEmailSubject: "Invoice.AutomaticReminderEmailSubject",
  AutomaticReminderEmailSubjectDescription: "Invoice.AutomaticReminderEmailSubjectDescription",
  AutomaticReminderEmailMessage: "Invoice.AutomaticReminderEmailMessage",
  AutomaticReminderEmailMessageDescription: "Invoice.AutomaticReminderEmailMessageDescription",
  AutomaticReminderFeeDepricationLimit: "Invoice.AutomaticReminderFeeDepricationLimit",
  AutomaticReminderFeeDepricationLimitDescription: "Invoice.AutomaticReminderFeeDepricationLimitDescription",
  CustomerInvoices: "Invoice.CustomerInvoices",
  CustomerInvoice: "Invoice.CustomerInvoice",
  DistributionStatus: "Invoice.DistributionStatus",
  InvoicedAmount: "Invoice.InvoicedAmount",
  WhenDoTheInvoiceDue: "Invoice.WhenDoTheInvoiceDue",
  AccountsReceivableLedger: "Invoice.AccountsReceivableLedger",
  LedgerDate: "Invoice.LedgerDate",
  UnpaidAmount: "Invoice.UnpaidAmount",
  CreditInvoices: "Invoice.CreditInvoices",
  SearchCustomer: "Invoice.SearchCustomer",
  RotAndRut: "Invoice.RotAndRut",
  ShowCreditSameMonth: "Invoice.ShowCreditSameMonth",
  OwnerHelpText: "Invoice.OwnerHelpText",
  InvoiceDateHelpText: "Invoice.InvoiceDateHelpText",
  DueDateHelpText: "Invoice.DueDateHelpText",
  CustomerHelpText: "Invoice.CustomerHelpText",
  InvoiceNumberHelpText: "Invoice.InvoiceNumberHelpText",
  InvoiceStatusHelpText: "Invoice.InvoiceStatusHelpText",
  InvoicedAmountHelpText: "Invoice.InvoicedAmountHelpText",
  UnpaidAmoutHelpText: "Invoice.UnpaidAmoutHelpText",
  PaymentStatusHelpText: "Invoice.PaymentStatusHelpText",
  LatestInvoices: "Invoice.LatestInvoices",
  SendEmailMessage: "Invoice.SendEmailMessage",
  NumOfInvoices: "Invoice.NumOfInvoices",
  AllInvoices: "Invoice.AllInvoices",
  RecurringInvoice: "Invoice.RecurringInvoice",
  RecurringInvoices: "Invoice.RecurringInvoices",
  ManageRecurring: "Invoice.ManageRecurring",
  HowRecurringSent: "Invoice.HowRecurringSent",
  FirstInvoice: "Invoice.FirstInvoice",
  HowOften: "Invoice.HowOften",
  RepeatUntilNotice: "Invoice.RepeatUntilNotice",
  LastInvoice: "Invoice.LastInvoice",
  RecurringDescriptionHelpText: "Invoice.RecurringDescriptionHelpText",
  RecurringOwnerDescription: "Invoice.RecurringOwnerDescription",
  ManageRecurringDescription: "Invoice.ManageRecurringDescription",
  HowRecurringSentDescription: "Invoice.HowRecurringSentDescription",
  FirstInvoiceDescription: "Invoice.FirstInvoiceDescription",
  LastInvoiceDescription: "Invoice.LastInvoiceDescription",
  HowOftenDescription: "Invoice.HowOftenDescription",
  RecurringDeliveryDateDescription: "Invoice.RecurringDeliveryDateDescription",
  RecurringFrequency_0: "Invoice.RecurringFrequency_0",
  RecurringFrequency_1: "Invoice.RecurringFrequency_1",
  RecurringFrequency_2: "Invoice.RecurringFrequency_2",
  RecurringFrequency_3: "Invoice.RecurringFrequency_3",
  RecurringSendType_0: "Invoice.RecurringSendType_0",
  RecurringSendType_1: "Invoice.RecurringSendType_1",
  RecurringAutomaticSendType_0: "Invoice.RecurringAutomaticSendType_0",
  RecurringAutomaticSendType_1: "Invoice.RecurringAutomaticSendType_1",
  RecurringInvoiceState_0: "Invoice.RecurringInvoiceState_0",
  RecurringInvoiceState_1: "Invoice.RecurringInvoiceState_1",
  RecurringInvoiceState_2: "Invoice.RecurringInvoiceState_2",
  RecurringPeriodisationStart: "Invoice.RecurringPeriodisationStart",
  RecurringPeriodisationDuration: "Invoice.RecurringPeriodisationDuration",
  Standard: "Invoice.Standard",
  Recurring: "Invoice.Recurring",
  DaysAfterInvoice: "Invoice.DaysAfterInvoice",
  OnInvoiceDate: "Invoice.OnInvoiceDate",
  RecurringSettings: "Invoice.RecurringSettings",
  InvoiceDetails: "Invoice.InvoiceDetails",
  ChangeInvoice: "Invoice.ChangeInvoice",
  RecurringSentInvoicesInfo: "Invoice.RecurringSentInvoicesInfo",
  RecurringTotalIncome: "Invoice.RecurringTotalIncome",
  EditInvoiceSettings: "Invoice.EditInvoiceSettings",
  RecurringInvoiceDescription: "Invoice.RecurringInvoiceDescription",
  RecurringInvoiceActiveBannerText: "Invoice.RecurringInvoiceActiveBannerText",
  RecurringInvoiceInactiveBannerText: "Invoice.RecurringInvoiceInactiveBannerText",
  RecurringInvoiceNotStartedBannerText: "Invoice.RecurringInvoiceNotStartedBannerText",
  RecurringStateFlowState_0: "Invoice.RecurringStateFlowState_0",
  RecurringStateFlowState_1: "Invoice.RecurringStateFlowState_1",
  RecurringStateFlowState_2: "Invoice.RecurringStateFlowState_2",
  RecurringStateFlowState_10: "Invoice.RecurringStateFlowState_10",
  RecurringStateFlowState_11: "Invoice.RecurringStateFlowState_11",
  RecurringStateFlowState_12: "Invoice.RecurringStateFlowState_12",
  RecurringListOwnerDescription: "Invoice.RecurringListOwnerDescription",
  RecurringListFirstInvoiceDescription: "Invoice.RecurringListFirstInvoiceDescription",
  RecurringListLastInvoiceDescription: "Invoice.RecurringListLastInvoiceDescription",
  RecurringListCustomerDescription: "Invoice.RecurringListCustomerDescription",
  RecurringListSentDescription: "Invoice.RecurringListSentDescription",
  RecurringListNumOfInvoicesDescription: "Invoice.RecurringListNumOfInvoicesDescription",
  RecurringListStatusDescription: "Invoice.RecurringListStatusDescription",
  RecurringListAmountDescription: "Invoice.RecurringListAmountDescription",
  RecurringListIncomeDescription: "Invoice.RecurringListIncomeDescription",
  RecurringStartedMessage: "Invoice.RecurringStartedMessage",
  RecurringStoppedMessage: "Invoice.RecurringStoppedMessage",
  StatusGraphTitle: "Invoice.StatusGraphTitle",
  UnpaidInvoices: "Invoice.UnpaidInvoices",
  QuotesWidgetState_0: "Invoice.QuotesWidgetState_0",
  QuotesWidgetState_1: "Invoice.QuotesWidgetState_1",
  QuotesWidgetState_2: "Invoice.QuotesWidgetState_2",
  QuotesWidgetState_3: "Invoice.QuotesWidgetState_3",
  QuotesWidgetState_4: "Invoice.QuotesWidgetState_4",
  QuotesWidgetState_5: "Invoice.QuotesWidgetState_5",
  QuotesWidgetState_6: "Invoice.QuotesWidgetState_6",
  RecurringFirstPeriodisationInfo: "Invoice.RecurringFirstPeriodisationInfo",
  RecurringSecondPeriodisationInfo: "Invoice.RecurringSecondPeriodisationInfo",
  PeriodisationAccounting: "Invoice.PeriodisationAccounting",
  RecurringPeriodisationHelpText: "Invoice.RecurringPeriodisationHelpText",
  CreditInvoiceSendType_0: "Invoice.CreditInvoiceSendType_0",
  CreditInvoiceSendType_1: "Invoice.CreditInvoiceSendType_1",
  CreditInvoiceSendType_2: "Invoice.CreditInvoiceSendType_2",
  CreditInvoiceSendType_3: "Invoice.CreditInvoiceSendType_3",
  CreditInvoiceSendTypeDescription_0: "Invoice.CreditInvoiceSendTypeDescription_0",
  CreditInvoiceSendTypeDescription_1: "Invoice.CreditInvoiceSendTypeDescription_1",
  CreditInvoiceSendTypeDescription_2: "Invoice.CreditInvoiceSendTypeDescription_2",
  CreditInvoiceSendTypeDescription_3: "Invoice.CreditInvoiceSendTypeDescription_3",
  CreditInvoiceCreateSuccessMessage: "Invoice.CreditInvoiceCreateSuccessMessage",
  CreditedInvoice: "Invoice.CreditedInvoice",
  CreditedInvoiceDescription: "Invoice.CreditedInvoiceDescription",
  RemainingAmountAfterCredit: "Invoice.RemainingAmountAfterCredit",
  UnpaidAmountAfterCredit: "Invoice.UnpaidAmountAfterCredit",
  ViewCreditInvoice: "Invoice.ViewCreditInvoice",
  CreditInvoice: "Invoice.CreditInvoice",
  CreditInvoiceDescription: "Invoice.CreditInvoiceDescription",
  ViewOriginalInvoice: "Invoice.ViewOriginalInvoice",
  PeriodisationInfo: "Invoice.PeriodisationInfo",
  MultiplePeriodisations: "Invoice.MultiplePeriodisations",
  Discard: "Invoice.Discard",
  SendType_0: "Invoice.SendType_0",
  SendType_1: "Invoice.SendType_1",
  SendType_2: "Invoice.SendType_2",
  SendType_Print: "Invoice.SendType_Print",
  ToReview: "Invoice.ToReview",
  ReviewMessage: "Invoice.ReviewMessage",
  OfWhichTax: "Invoice.OfWhichTax",
  DaysOfPaymentTerms: "Invoice.DaysOfPaymentTerms",
  RutRotServices: "Invoice.RutRotServices",
  RutRotServicesDescription: "Invoice.RutRotServicesDescription",
  RutRotInvoice: "Invoice.RutRotInvoice",
  RutRotInvoiceDescription: "Invoice.RutRotInvoiceDescription",
  RutRotPersonNumberDescription: "Invoice.RutRotPersonNumberDescription",
  RotPropertyType: "Invoice.RotPropertyType",
  RotPropertyTypeDescription: "Invoice.RotPropertyTypeDescription",
  RutRot: "Invoice.RutRot",
  RutRotDescription: "Invoice.RutRotDescription",
  RutRotTabContentTitle: "Invoice.RutRotTabContentTitle",
  HouseWorkType_0: "Invoice.HouseWorkType_0",
  HouseWorkType_1: "Invoice.HouseWorkType_1",
  HouseWorkType_2: "Invoice.HouseWorkType_2",
  RotPropertyType_0: "Invoice.RotPropertyType_0",
  RotPropertyType_1: "Invoice.RotPropertyType_1",
  RotPropertyType_2: "Invoice.RotPropertyType_2",
  TenantsOrgNumber: "Invoice.TenantsOrgNumber",
  ApartmentNumber: "Invoice.ApartmentNumber",
  HouseWorkOtherCosts: "Invoice.HouseWorkOtherCosts",
  HouseWorkOtherCostsDescription: "Invoice.HouseWorkOtherCostsDescription",
  NumberOfHours: "Invoice.NumberOfHours",
  TypeOfWork: "Invoice.TypeOfWork",
  MaterialCost: "Invoice.MaterialCost",
  RutRotSummary: "Invoice.RutRotSummary",
  RutRotSummaryDescription: "Invoice.RutRotSummaryDescription",
  TotalLaborCost: "Invoice.TotalLaborCost",
  TotalMaterialCost: "Invoice.TotalMaterialCost",
  OtherExpenses: "Invoice.OtherExpenses",
  TotalAmount: "Invoice.TotalAmount",
  MaterialCostSuggestionsDescription: "Invoice.MaterialCostSuggestionsDescription",
  MaterialCostSuggestions: "Invoice.MaterialCostSuggestions",
  RutRotSummaryService: "Invoice.RutRotSummaryService",
  RutRotSummaryCost: "Invoice.RutRotSummaryCost",
  RutRotHoursValidation: "Invoice.RutRotHoursValidation",
  AmountDistribution: "Invoice.AmountDistribution",
  PsFinanceInterface: "Invoice.PsFinanceInterface",
  PsText1: "Invoice.PsText1",
  PsText2: "Invoice.PsText2",
  SendToDebtCollectionDialogTitle: "Invoice.SendToDebtCollectionDialogTitle",
  SendToDebtCollectionDialogDescription: "Invoice.SendToDebtCollectionDialogDescription",
  SendToDebtCollectionDialogPlaceholder: "Invoice.SendToDebtCollectionDialogPlaceholder",
  Complete: "Invoice.Complete",
  SendToDebtCollectionSuccessMessage: "Invoice.SendToDebtCollectionSuccessMessage",
  AgentInvoices: "Invoice.AgentInvoices",
  PsSyncDelay: "Invoice.PsSyncDelay",
  InvoiceHasRowLevelDimensions: "Invoice.InvoiceHasRowLevelDimensions",
  ChangeDimensions: "Invoice.ChangeDimensions",
  IncomingInvoicePeriodisationNotEditable: "Invoice.IncomingInvoicePeriodisationNotEditable",
  RecurringInvoiceIconToolTip: "Invoice.RecurringInvoiceIconToolTip",
  RutAppliedToolTip: "Invoice.RutAppliedToolTip",
  RutNotAppliedToolTip: "Invoice.RutNotAppliedToolTip",
  RotAppliedToolTip: "Invoice.RotAppliedToolTip",
  RotNotAppliedToolTip: "Invoice.RotNotAppliedToolTip",
  WaitingForSkvPayout: "Invoice.WaitingForSkvPayout",
  WaitingForSkvPayoutToolTip: "Invoice.WaitingForSkvPayoutToolTip",
  CreditInfoWhenTimeReportInvoice: "Invoice.CreditInfoWhenTimeReportInvoice",
  AssignOwner: "Invoice.AssignOwner",
  ReAssignResponsibility: "Invoice.ReAssignResponsibility",
  AssignNewOwnerSuccessMessage: "Invoice.AssignNewOwnerSuccessMessage",
  DraftTodoCompleteHeader: "Invoice.DraftTodoCompleteHeader",
  DraftTodoCompleteDescription: "Invoice.DraftTodoCompleteDescription",
  DraftTodoIncompleteHeader: "Invoice.DraftTodoIncompleteHeader",
  DraftTodoIncompleteDescription: "Invoice.DraftTodoIncompleteDescription",
  AllArticles: "Invoice.AllArticles",
  NoCustomerName: "Invoice.NoCustomerName",
  MarkAsSentDescription: "Invoice.MarkAsSentDescription",
  AdditionalInformationComment: "Invoice.AdditionalInformationComment",
  AdditionalInformationAttachment: "Invoice.AdditionalInformationAttachment",
  AdditionalInformationAttachmentDescription: "Invoice.AdditionalInformationAttachmentDescription",
  SelfInvoiceTodoMainActionTitle: "Invoice.SelfInvoiceTodoMainActionTitle",
  SelfInvoiceTodoMainActionSubTitle: "Invoice.SelfInvoiceTodoMainActionSubTitle",
  SelfInvoiceDetails: "Invoice.SelfInvoiceDetails",
  SelfInvoiceRows: "Invoice.SelfInvoiceRows",
  SelfInvoiceOCR: "Invoice.SelfInvoiceOCR",
  SelfInvoiceOCRDescription: "Invoice.SelfInvoiceOCRDescription",
  OrganizationNumber: "Invoice.OrganizationNumber",
  SelfInvoiceTotalMismatchWarning: "Invoice.SelfInvoiceTotalMismatchWarning",
  SelfInvoiceUpdatedTotalMismatchWarning: "Invoice.SelfInvoiceUpdatedTotalMismatchWarning",
  Source_0: "Invoice.Source_0",
  Source_1: "Invoice.Source_1",
  Source: "Invoice.Source",
  SelfInvoiceDimensionsDescription: "Invoice.SelfInvoiceDimensionsDescription",
  EnableCustomerInvoicing: "Invoice.EnableCustomerInvoicing",
  InvoiceWaitingActivationTitle: "Invoice.InvoiceWaitingActivationTitle",
  InvoiceWaitingActivationDescription: "Invoice.InvoiceWaitingActivationDescription",
  HaveYouSentInvoicesBefore: "Invoice.HaveYouSentInvoicesBefore",
  InvoiceEUCustomers: "Invoice.InvoiceEUCustomers",
  HasRegisteredForFTax: "Invoice.HasRegisteredForFTax",
  LastInvoiceNumber: "Invoice.LastInvoiceNumber",
  LastInvoiceNumberDescription: "Invoice.LastInvoiceNumberDescription",
  NextInvoiceNumber: "Invoice.NextInvoiceNumber",
  NextInvoiceNumberDescription: "Invoice.NextInvoiceNumberDescription",
  InvoiceActivationMessageTitle: "Invoice.InvoiceActivationMessageTitle",
  InvoiceActivationMessage: "Invoice.InvoiceActivationMessage",
  ActivationFormExitWarningDescription: "Invoice.ActivationFormExitWarningDescription",
  SelfInvoiceCreateFromInfo: "Invoice.SelfInvoiceCreateFromInfo",
  SelfInvoiceCreateFromTip: "Invoice.SelfInvoiceCreateFromTip",
  SelfInvoiceCreateSuccess: "Invoice.SelfInvoiceCreateSuccess",
  SendAsCustomerInvoice: "Invoice.SendAsCustomerInvoice",
  EditSelfInvoice: "Invoice.EditSelfInvoice",
  SelfInvoice: "Invoice.SelfInvoice",
  ApproveSuccessMessage: "Invoice.ApproveSuccessMessage",
  RejectSuccessMessage: "Invoice.RejectSuccessMessage",
  RotDeductionRate: "Invoice.RotDeductionRate",
  RotDeductionDescription: "Invoice.RotDeductionDescription",
  RotDeductionWarning: "Invoice.RotDeductionWarning",
  SendInvoiceMailsTo_CustomerCompany: "Invoice.SendInvoiceMailsTo_CustomerCompany",
  SendInvoiceMailsTo_ReferencePerson: "Invoice.SendInvoiceMailsTo_ReferencePerson",
  SendInvoiceMailsTo_Other: "Invoice.SendInvoiceMailsTo_Other",
  ReminderManagement: "Invoice.ReminderManagement",
  ReminderManagementDescription: "Invoice.ReminderManagementDescription",
  AutoReminder: "Invoice.AutoReminder",
  ManualReminder: "Invoice.ManualReminder",
  HighAmountWarningTitle: "Invoice.HighAmountWarningTitle",
  HighAmountWarningMessage: "Invoice.HighAmountWarningMessage",
  HighAmountWarningTotalLabel: "Invoice.HighAmountWarningTotalLabel",
  HighAmountWarningConfirm: "Invoice.HighAmountWarningConfirm",
  EditPeriodisation: "Invoice.EditPeriodisation",
  }
export default Invoice;